export default __webpack_public_path__ + "static/media/galleryImage2.457c3d4e.jpg";